module.exports = __webpack_public_path__ + "media/stable/components/site/scorecard/assets/decagon-3c9a0851b75fd39d99adcdfe648cd161.svg";